






























































































































































































































































































































































































































































import detailDialog from "./detailDialog.vue";
import { rollCallList, rollCallListData } from "@/api/rollCallRecord";
import { dateFormat } from "@/utils/timeFormat";
import { Component, Prop, Vue } from "vue-property-decorator";
import { getClassCourseList } from "@/api/classManagement";
import { roolCallExport } from "@/api/export";
import { exportLoop } from "@/utils/export";
import { classroomSelectListApi } from "@/api/classRoom";
import { PageModule } from "@/store/module/page";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import {
  getSelectClassList,
  getSelectCourseList,
  getSeleSubjectsList,
} from "@/api/globalSearch";
import CommonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

@Component({
  name: "classDetailSigned",
  components: {
    detailDialog,
    CommonSearchFormWrapper,
    commonStaffPullDown,
    commonDateRangeSelector,
  },
})
export default class extends Vue {
  currentStaffList: any[] = [];
  currentTeacherList: any[] = [];
  currentCourseList: any[] = [];
  searchInfo: any = {
    consume_number_start: "",
    consume_number_end: "",
    real_consume_number_start: "",
    real_consume_number_end: "",
    course_type: -1,
    status_type: -1,
    sort_field: "lesson_full_start_time",
    sort_type: "desc",
    teacher_id: "" as number | string,
    teacher_list: [] as any[],
    classroom_id: "" as number | string,
    roll_call_date: [] as string[],
    lesson_date: [] as string[],
    subject_ids: [] as number[],
    lesson_id: "",
    follow_staff_id: "",
    follow_staff_list: [],
  };
  searchClassList: {
    class_id: number;
    name: string;
  }[] = [];
  searchCourseList: {
    course_id: number;
    title: string;
  }[] = [];
  searchSubjectList: {
    subject_id: number;
    subject_title: string;
  }[] = [];
  searchClassRoomList: {
    classroom_id: number;
    name: string;
  }[] = [];
  tableData: any[] = [];
  page: number = 1;
  pageSize: number = 10;
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total: number = 0;
  detailFormId: number = 0;
  detailFormTitle: string = "";
  detailFormVisible: boolean = false;
  created() {
    const cid = this.$route.query.id;
    if (PageModule.latestRoute === "rollCallDetails") {
      const cache = PageModule.pageInfo.classDetailSigned;
      if (cache.search_info) {
        this.searchInfo = cache.search_info;
      }
      if (cache.page) {
        this.page = cache.page;
      }
      if (cache.page_size) {
        this.pageSize = cache.page_size;
      }
    }
    if (cid) {
      getClassCourseList({ class_id: Number(cid) }).then((res: any) => {
        if (res.error_code === 0) {
          this.currentCourseList = res.data.list;
        }
      });
      this.handleSearchCourse("");
      this.handleSearchSubject("");
      classroomSelectListApi({
        page: 1,
        page_size: 1000,
      }).then((res: any) => {
        if (res.error_code === 0) {
          this.searchClassRoomList = res.data.list;
        }
      });
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
    }
  }
  getTime(e: any) {
    const weekZh = ["日", "一", "二", "三", "四", "五", "六"];
    const v = "（周" + weekZh[e.getDay()] + "）";
    const format = dateFormat("YYYY-mm-dd HH:MM", e);
    return format.slice(0, 10) + v + format.slice(11);
  }
  getToClassTime(e: any) {
    const weekZh = ["日", "一", "二", "三", "四", "五", "六"];
    const v = "（周" + weekZh[e.getDay()] + "）";
    const format = dateFormat("YYYY-mm-dd", e);
    return format.slice(0, 10) + v + format.slice(11);
  }
  handleSearchClass(v?: string) {
    getSelectClassList({
      page: 1,
      page_size: 100,
      key_word: v,
    }).then((res) => {
      this.searchClassList = res.data.list;
    });
  }
  handleSearchCourse(v?: string) {
    getSelectCourseList({
      page: 1,
      page_size: 100,
      key_word: v,
    }).then((res) => {
      this.searchCourseList = res.data.list;
    });
  }
  handleSearchSubject(v?: string) {
    getSeleSubjectsList({
      page: 1,
      page_size: 100,
      key_word: v,
    }).then((res) => {
      this.searchSubjectList = res.data.list;
    });
  }
  consumeNumberCheck() {
    if (
      this.searchInfo.consume_number_start &&
      this.searchInfo.consume_number_end
    ) {
      if (
        Number(this.searchInfo.consume_number_start) >
        Number(this.searchInfo.consume_number_end)
      ) {
        this.$message({
          type: "warning",
          message: "排课课时输入有误",
        });
        this.searchInfo.consume_number_end =
          this.searchInfo.consume_number_start;
        return false;
      }
    }
    this.handleSearch();
  }
  realConsumeNumberCheck() {
    if (
      this.searchInfo.real_consume_number_start &&
      this.searchInfo.real_consume_number_end
    ) {
      if (
        Number(this.searchInfo.real_consume_number_start) >
        Number(this.searchInfo.real_consume_number_end)
      ) {
        this.$message({
          type: "warning",
          message: "耗课数输入有误",
        });
        this.searchInfo.real_consume_number_end =
          this.searchInfo.real_consume_number_start;
        return false;
      }
    }
    this.handleSearch();
  }
  getList(params: { page: number; page_size: number }) {
    const _t = this as any;
    const data: rollCallListData = {
      page: params.page,
      page_size: params.page_size,
    };
    data.class_id = Number(this.$route.query.id);
    if (_t.searchInfo.sort_field) {
      data.sort_field = _t.searchInfo.sort_field;
    }
    if (_t.searchInfo.sort_type) {
      data.sort_type = _t.searchInfo.sort_type;
    }
    if (_t.searchInfo.teacher_id) {
      data.teacher_id = _t.searchInfo.teacher_id;
    }
    if (_t.searchInfo.course_id) {
      data.course_id = _t.searchInfo.course_id;
    }
    if (_t.searchInfo.follow_staff_id) {
      data.staff_id = _t.searchInfo.follow_staff_id;
    }
    if (_t.searchInfo.consume_number_start) {
      data.consume_number_start = _t.searchInfo.consume_number_start;
    }
    if (_t.searchInfo.consume_number_end) {
      data.consume_number_end = _t.searchInfo.consume_number_end;
    }
    if (
      _t.searchInfo.real_consume_number_start &&
      _t.searchInfo.real_consume_number_start
    ) {
      data.real_consume_number_start = _t.searchInfo.real_consume_number_start;
      data.real_consume_number_end = _t.searchInfo.real_consume_number_end;
    }
    if (
      _t.searchInfo.roll_call_date &&
      _t.searchInfo.roll_call_date.length === 2
    ) {
      data.roll_call_start_date = _t.searchInfo.roll_call_date[0];
      data.roll_call_end_date = _t.searchInfo.roll_call_date[1];
    }
    if (_t.searchInfo.lesson_date && _t.searchInfo.lesson_date.length === 2) {
      data.lesson_start_date = _t.searchInfo.lesson_date[0];
      data.lesson_end_date = _t.searchInfo.lesson_date[1];
    }
    if (_t.searchInfo.course_type > -1) {
      data.course_type = _t.searchInfo.course_type;
    }
    if (_t.searchInfo.subject_ids && _t.searchInfo.subject_ids.length > 0) {
      data.subject_ids = _t.searchInfo.subject_ids;
    }
    if (_t.searchInfo.status_type > -1) {
      data.status = _t.searchInfo.status_type;
    }
    if (_t.searchInfo.classroom_id) {
      data.classroom_id = _t.searchInfo.classroom_id;
    }
    rollCallList(data).then((res: any) => {
      if (res.error_code === 0) {
        res.data.list.map((item: any) => {
          const i = new Date(item.lesson_date.replace(/-/g, "/")).getDay();
          item.weekZh = ["日", "一", "二", "三", "四", "五", "六"][i];
        });
        this.tableData = res.data.list;
        this.total = res.data.total;
        this.page = params.page;
      }
    });
  }
  handleExport() {
    const cid = Number(this.$route.query.id);
    const opt: any = {
      class_id: cid,
    };
    if (this.searchInfo.sign_time && this.searchInfo.sign_time.length === 2) {
      opt.roll_call_start_date = dateFormat(
        "YYYY-mm-dd",
        new Date(this.searchInfo.sign_time[0])
      );
      opt.roll_call_end_date = dateFormat(
        "YYYY-mm-dd",
        new Date(this.searchInfo.sign_time[1])
      );
    }
    if (
      this.searchInfo.lesson_time &&
      this.searchInfo.lesson_time.length === 2
    ) {
      opt.lesson_start_date = dateFormat(
        "YYYY-mm-dd",
        new Date(this.searchInfo.lesson_time[0])
      );
      opt.lesson_end_date = dateFormat(
        "YYYY-mm-dd",
        new Date(this.searchInfo.lesson_time[1])
      );
    }
    if (this.searchInfo.staff_id) {
      opt.staff_id = this.searchInfo.staff_id;
    }
    if (this.searchInfo.teacher_id) {
      opt.teacher_id = this.searchInfo.teacher_id;
    }
    if (this.searchInfo.course_id) {
      opt.course_id = this.searchInfo.course_id;
    }
    roolCallExport(opt).then((res: any) => {
      if (res.error_code === 0) {
        exportLoop(res.data.task_id);
      }
    });
  }
  handleSearch() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }
  handleSearchReset() {
    this.searchInfo = {
      sort_type: "desc",
      sort_field: "",
      status_type: -1,
    };
    this.handleSearch();
  }
  openDetailDialog(row: any) {
    PageModule.SET_PAGE_INFO({
      name: "classDetailSigned",
      key: "search_info",
      value: { ...this.searchInfo },
    });
    this.$router.push({
      path: "roll_call_detail",
      query: {
        id: row.roll_call_id,
      },
    });
  }
  handlePagerChange(e: number) {
    PageModule.SET_PAGE_INFO({
      name: "classDetailSigned",
      key: "page",
      value: e,
    });
    this.page = e;
    this.getList({
      page: e,
      page_size: this.pageSize,
    });
  }
  handlePagerSizeChange(e: number) {
    PageModule.SET_PAGE_INFO({
      name: "classDetailSigned",
      key: "page_size",
      value: e,
    });
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
    });
  }
  // 排序
  handleSortChange(data: { prop: string; order: string }) {
    this.searchInfo.sort_field = data.prop;
    if (data.order == "descending") {
      this.searchInfo.sort_type = "desc";
    } else if (data.order == "ascending") {
      this.searchInfo.sort_type = "asc";
    } else {
      this.searchInfo.sort_type = "";
    }
    this.getList({
      page: this.page,
      page_size: this.pageSize,
    });
  }
}
